import * as Yup from 'yup';
import { SarlaftVinculation } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftVinculation = {
    typeEntailment: '',
};

export const validationSchema = Yup.object({
    typeEntailment: Yup.string().required(
        'La clase de vinculación obligatoria'
    ),
});
